import type { ApiResponse, PaginatedData, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import type { ListPersonsParams, Person, PersonCreateRequest, PersonUpdateRequest } from "../types";

export const personsService = {
	async list(params: ListPersonsParams): Promise<PaginatedData<Person>> {
		const response = await apiClient.get<ApiResponse<PaginatedData<Person>>>("/persons", {
			params,
		});
		return (response.data as SuccessResponse<PaginatedData<Person>>).data;
	},

	async getById(id: string): Promise<Person> {
		const response = await apiClient.get<SuccessResponse<Person>>(`/persons/${id}`);
		return response.data.data;
	},

	async create(data: PersonCreateRequest): Promise<Person> {
		const response = await apiClient.post<SuccessResponse<Person>>("/persons", data);
		return response.data.data;
	},

	async update(id: string, data: PersonUpdateRequest): Promise<Person> {
		const response = await apiClient.patch<SuccessResponse<Person>>(`/persons/${id}`, data);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/persons/${id}`);
	},
};
